import request from "@/utils/request";

const obj = {
    agentGetParkingRecord(params) {
        if (!params.phone){
            params.memberType=null
        }

        return request.get(`/fund/parkingRecord/agentGetParkingRecord`, {
            params
        })
    },
    agentGetParkingDailyReport(params) {
        return request.get(`/fund/parkingRecord/agentGetParkingDailyReport`, {
            params
        })
    },
    agentGetParkingMonthlyReport(params) {
        return request.get(`/fund/parkingRecord/agentGetParkingMonthlyReport`, {
            params
        })
    }
}
export default obj;
